import createVueComponent from '../createVueComponent';

const Reply = createVueComponent('ReplyIcon', [
  ['polyline', { points: '9 17 4 12 9 7' }],
  ['path', { d: 'M20 18v-2a4 4 0 00-4-4H4' }],
]);

export default Reply;
